// extracted by mini-css-extract-plugin
export default {"icon":"ServicesCard_icon__ToUul","title":"ServicesCard_title__G6OWV","description":"ServicesCard_description__6iV4c"};